import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import EsccValidationPageUI from './EsccValidationPageUI.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'

class EsccValidationPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      esccValidationList: null,
      validatingBankAccountNumber: null,
      updateMode: false,
      selectedAccount: null,
    }
  }

  render() {
    return (
      <EsccValidationPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        esccValidationList={this.state.esccValidationList}
        onRefreshClick={this.onRefreshClick}
        onValidateClick={this.onValidateClick}
        updateMode={this.state.updateMode}
        onCancelClick={this.onCancelClick}
        selectedAccount={this.state.selectedAccount}
      />
    )
  }

  componentDidMount() {
    this.getEsccValidationList()
  }

  getEsccValidationList = () => {
    let context = this.props.context
    RestApiUtils.get(context, `/api/su/esccValidation`, this.getEsccValidationListCallback, {}, {})
  }

  getEsccValidationListCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      esccValidationList: response.esccValidationList
    })
  }

  onValidateClick = (event) => {
    let bankAccountNumber = event.target.getAttribute('data-row-id') || event.currentTarget.getAttribute('rowId')
    let account = this.state.esccValidationList.find(a => a.bankAccountNumber === bankAccountNumber)
    this.setState({ updateMode: true, selectedAccount: account })
  }

  onCancelClick = () => {
    this.setState({ updateMode: false, selectedAccount: null })
  }

  onRefreshClick = () => {
    this.setState({ esccValidationList: null, errorList: null }, () => {
      this.getEsccValidationList()
    })
  }
}

export default withRouter(EsccValidationPageSF)